import { VehicleRegistrationResult } from '@mark43/dex-api';
import {
    HStack,
    VStack,
    Box,
    Card,
    CardBody,
    InlineBanner,
    Text,
    DataList,
    DataItem,
} from '@cad-arc';
const SUCCESS_STATES = ['ACTV', 'ORDR'];
const ATTENTION_STATES = ['CANC', 'CA19', 'CAPR', 'EXPI', 'INAC', 'REVO', 'SUSP', 'SWAP'];

function getCode(registrationStatusCode: string): string {
    // Field may come back with a date like 'ACTV/2025-10-01'
    return registrationStatusCode.split('/')[0];
}

const getVehicleRegistrationStatusInlineBannerStatus = (
    registrationStatusCode?: string
): 'success' | 'attention' | undefined => {
    if (!registrationStatusCode) {
        return undefined;
    }
    const code = getCode(registrationStatusCode);
    if (SUCCESS_STATES.includes(code)) {
        return 'success';
    }
    if (ATTENTION_STATES.includes(code)) {
        return 'attention';
    }
    return undefined;
};

export function DexParsedVehicleSummary({ vehicle }: { vehicle: VehicleRegistrationResult }) {
    const inlineBannerStatus = getVehicleRegistrationStatusInlineBannerStatus(
        vehicle.registrationStatusCode
    );
    return (
        <Card>
            {inlineBannerStatus && vehicle.registrationStatusCode && (
                <Box p="2">
                    <InlineBanner
                        status={inlineBannerStatus}
                        title={`Vehicle Registration: ${getCode(vehicle.registrationStatusCode)}`}
                    />
                </Box>
            )}
            <CardBody>
                <VStack align="left">
                    <VStack align="left">
                        <HStack alignItems="flex-start" gap="48px">
                            <VStack align="left">
                                <Text variant="headingSm">
                                    {vehicle.vehicleMakeCode ?? ''} {vehicle.vehicleModelCode ?? ''}
                                </Text>
                                <DataList>
                                    <DataItem dataKey="Year">{vehicle.vehicleYear}</DataItem>
                                    <DataItem dataKey="Style">{vehicle.vehicleStyleCode}</DataItem>
                                    <DataItem dataKey="Color">{vehicle.vehicleColorCode}</DataItem>
                                    <DataItem dataKey="VIN">
                                        {vehicle.vehicleIdentificationNumber}
                                    </DataItem>
                                    <DataItem dataKey="Ins. Co.">
                                        {vehicle.autoInsuranceCarrier}
                                    </DataItem>
                                </DataList>
                            </VStack>
                            <VStack align="left">
                                <Text variant="headingSm">{vehicle.licensePlateNumber ?? ''}</Text>
                                <DataList>
                                    <DataItem dataKey="Reg. Status">
                                        {vehicle.registrationStatusCode}
                                    </DataItem>
                                    <DataItem dataKey="Plate Type">
                                        {vehicle.licensePlateTypeCode}
                                    </DataItem>
                                    <DataItem dataKey="Iss. Date">{vehicle.issueDate}</DataItem>
                                    <DataItem dataKey="Exp. Date">
                                        {vehicle.expirationDate}
                                    </DataItem>
                                </DataList>
                            </VStack>
                        </HStack>
                    </VStack>
                </VStack>
            </CardBody>
        </Card>
    );
}
